import { HttpPostFunction } from "@lookiero/sty-psp-http";
import {
  IsTrendingForYouOfferingEnabledView,
  ViewIsTrendingForYouOfferingEnabledResult,
} from "../../../projection/offering/viewIsTrendingForYouOfferingEnabled";

interface ViewIsTrendingForYouOfferingEnabledResponse {
  readonly active: boolean;
}

interface HttpTrendingForYouOfferingEnabledView extends IsTrendingForYouOfferingEnabledView {}

interface HttpTrendingForYouOfferingEnabledViewFunctionArgs {
  readonly httpPost: HttpPostFunction;
}

interface HttpTrendingForYouOfferingEnabledViewFunction {
  (args: HttpTrendingForYouOfferingEnabledViewFunctionArgs): HttpTrendingForYouOfferingEnabledView;
}

const httpTrendingForYouOfferingEnabledView: HttpTrendingForYouOfferingEnabledViewFunction =
  ({ httpPost }) =>
  async ({ signal }) =>
    await httpPost<ViewIsTrendingForYouOfferingEnabledResponse, ViewIsTrendingForYouOfferingEnabledResult>({
      endpoint: "/trending/v1/has-access",
      body: {},
      signal,
      result: {
        error: false,
        success: (response) => response?.active ?? false,
      },
    });

export { httpTrendingForYouOfferingEnabledView };
